import { useEffect, useState } from "react";

// Tracks whether the browser thinks it has network connectivity.
// Drives the offline lock indicator on the AI Assistant entry points,
// since the assistant requires a live connection to Claude.
export function useOnline() {
  const [online, setOnline] = useState(() =>
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  return online;
}
